// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M11.9999 1.76416L21.9458 21.656L11.9999 18.5479L2.05396 21.656L11.9999 1.76416Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-navigation-arrow-filled')
export default class NavigationArrowFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'navigation-arrow-filled',
    }
  }
}
